import axios from '@/shared/utils/axios-init';
import filterConnections from '@/shared/utils/helpers/filterAmlConnections';

const initialState = {
  baseHistory: {
    list: [],
    lastPage: 1,
  },
  currencies: [],
  usdtBalance: null,
  verifyInfo: null,
  investigationInfo: null,
};

const getters = {
  getList(state) {
    return state.investigationInfo.indirects.connections;
  },
  getIncoming(_, { getList }) {
    return filterConnections(getList);
  },
  getOutgoing(_, { getList }) {
    return filterConnections(getList, true);
  },
};

const actions = {
  async fetchAmlParams({ commit }) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const { data } = await axios.get('/service/aml/params', { headers: { Authorization: `Bearer ${token}` } });

      commit('setCurrencies', data.currencies);
      commit('setUsdtBalance', data.user_wallets.amount);

      return data;
    } catch (err) {
      return { error: err.message };
    }
  },

  async verifyAddress({ commit }, params) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const { data } = await axios.post(
        '/service/aml/addressverification',
        params,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      commit('setVerifyInfo', JSON.parse(data.data.results));

      return null;
    } catch (err) {
      const msg = err.response ? err.response.data.err : err.message;
      return msg;
    }
  },

  async verifyTransaction({ commit }, params) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const { data } = await axios.post(
        '/service/aml/transactionverification',
        params,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      commit('setVerifyInfo', JSON.parse(data.data.results));

      return null;
    } catch (err) {
      const msg = err.response ? err.response.data.err : err.message;
      return msg;
    }
  },

  async investigateAddress({ commit }, params) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const { data } = await axios.post(
        '/service/aml/addressinvestigation',
        params,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      commit('setInvestigationInfo', JSON.parse(data.data.results));

      return null;
    } catch (err) {
      const msg = err.response ? err.response.data.err : err.message;
      return msg;
    }
  },

  async fetchBaseHistory({ commit }, { page = 1, type }) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const { data: { data } } = await axios.post(
        '/service/aml/history',
        { page, type, perpage: 10 },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      commit('setBaseHistory', {
        list: data.data,
        lastPage: data.last_page,
      });

      return null;
    } catch (err) {
      return err.message;
    }
  },
};

const mutations = {
  setCurrencies(state, payload) {
    state.currencies = payload;
  },
  setUsdtBalance(state, payload) {
    state.usdtBalance = payload;
  },
  setVerifyInfo(state, payload) {
    state.verifyInfo = payload;
  },
  setBaseHistory(state, payload) {
    state.baseHistory = payload;
  },
  setInvestigationInfo(state, payload) {
    state.investigationInfo = payload;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/modules/Account/modules/aml.js